import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config/api';

// Homework notification bell for center-students: shows pending count (blinking)
// and a dropdown of assigned homework with a "Làm ngay" link that opens the exam.
// No-ops for students who aren't in a center (empty list).
export default function HomeworkBell() {
  const [data, setData] = useState({ homeworks: [], pending: 0 });
  const [open, setOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  const wrapRef = useRef(null);

  const load = () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API_BASE}/student/homework`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setData(d); })
      .catch(() => {});
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const pending = data.pending || 0;
  const list = data.homeworks || [];
  const go = (hw) => { setOpen(false); navigate(hw.url); };

  return (
    <div ref={wrapRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        title="Bài tập được giao"
        className="relative p-2 rounded-full hover:bg-white/10 transition-colors"
      >
        <svg className={`w-6 h-6 text-white ${pending > 0 ? 'animate-bounce' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5m6 0v1a3 3 0 1 1-6 0v-1m6 0H9" />
        </svg>
        {pending > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[11px] font-bold grid place-items-center ring-2 ring-[#0096b1] animate-pulse">
            {pending}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-[85vw] bg-white rounded-xl shadow-2xl border border-gray-100 z-[60] overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
            <span className="font-bold text-[#2b5356]">Bài tập được giao</span>
            {pending > 0 && <span className="text-xs font-semibold text-red-500">{pending} chưa làm</span>}
          </div>
          {list.length === 0 ? (
            <div className="px-4 py-8 text-center text-gray-400 text-sm">Chưa có bài tập nào 🎉</div>
          ) : (
            <div className="max-h-96 overflow-y-auto divide-y divide-gray-50">
              {(showAll ? list : list.slice(0, 5)).map((hw) => (
                <div key={hw.homework_id} className="px-4 py-3 flex items-start gap-2">
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-medium text-gray-800 truncate">{hw.title}</div>
                    <div className="text-xs text-gray-400">
                      <span className="capitalize">{hw.skill || ''}</span>{hw.parts_label ? ` · ${hw.parts_label}` : ''}{hw.class_name ? ` · ${hw.class_name}` : ''}
                    </div>
                  </div>
                  {hw.done ? (
                    <span className="text-xs font-semibold text-emerald-600 shrink-0 mt-0.5">✓ Đã làm</span>
                  ) : hw.locked ? (
                    <button onClick={() => { setOpen(false); navigate('/vip-packages'); }}
                      title="Cần gói VIP để làm bài tập này"
                      className="text-xs font-semibold text-white bg-[#eb7e37] hover:bg-[#d96f2b] px-2.5 py-1 rounded-lg shrink-0">
                      Nâng cấp VIP
                    </button>
                  ) : (
                    <button onClick={() => go(hw)} className="text-xs font-semibold text-white bg-[#0096b1] hover:bg-[#007d93] px-2.5 py-1 rounded-lg shrink-0">
                      Làm ngay
                    </button>
                  )}
                </div>
              ))}
              {list.length > 5 && (
                <button onClick={() => setShowAll((v) => !v)}
                  className="w-full py-2.5 text-center text-xs font-semibold text-[#0096b1] hover:bg-gray-50">
                  {showAll ? 'Thu gọn' : `Xem thêm (${list.length - 5})`}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
